module.exports = __webpack_public_path__ + "img/img59.6b85177b.svg";